/**
 * Purpose: Loading placeholders for the dashboard shell and its module panels.
 * Inputs: none (DashboardSkeleton = whole shell; ModulePanelSkeleton = one panel,
 *         also used as the Suspense fallback while a module chunk downloads).
 * Outputs: pulsing placeholders; containers carry aria-busy.
 */
import React from 'react';
import { Skeleton, SkeletonText } from '../ui';

export const ModulePanelSkeleton = () => (
  <div
    aria-busy="true"
    className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900 sm:p-5"
  >
    <Skeleton className="mb-4 h-5 w-40" />
    <SkeletonText lines={4} />
  </div>
);

export const DashboardSkeleton = () => (
  <div
    aria-busy="true"
    aria-label="Loading dashboard"
    className="mx-auto max-w-screen-2xl px-4 py-4 sm:px-6 lg:px-8"
  >
    <Skeleton className="h-16 w-full rounded-2xl" />
    <div className="mt-4 lg:grid lg:grid-cols-[15rem_minmax(0,1fr)] lg:gap-6">
      <div className="hidden space-y-2 lg:block">
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-9 w-full rounded-xl" />
        ))}
      </div>
      <div className="flex gap-2 lg:hidden">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-9 w-24 rounded-full" />
        ))}
      </div>
      <div className="mt-4 lg:mt-0">
        <ModulePanelSkeleton />
      </div>
    </div>
  </div>
);

export default DashboardSkeleton;
